




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { LearningGroupCourse, MobileGetter } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';

@Component({
  components: {
    BriocheBackgroundImage,
  },
  computed: {
    ...mapState('globals', ['user']),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CourseItemContent extends Vue {
  @Prop(Object) private readonly course!: LearningGroupCourse;
  @Prop(Number) private readonly courseNumber!: number | undefined;

  private isMobile!: MobileGetter;

  private expanded = false;
  private isSendingNotifyRequest = false;
  private moreButtonClass = 'more-button';

  private get courseDescription(): string | null {
    if (this.course.description.replace('<p></p>', '').trim().length === 0) {
      return null;
    }

    if (this.expanded) {
      return this.course.description;
    }

    let numCharsToKeep = 130;
    if (this.$mq === 'medium') {
      numCharsToKeep = 110;
    } else if (this.isMobile(this.$mq)) {
      numCharsToKeep = 80;
    }

    const minCharsToKeep = 80;
    let firstParagraph = this.course.description.split('\r\n\r\n')[0].replace(/<\/?p>/g, '');

    // Don't shorten short descriptions
    if (firstParagraph.length <= numCharsToKeep) {
      return this.course.description;
    }

    // Don't cut off in the middle of a word
    while (
      firstParagraph[numCharsToKeep] !== ' ' &&
      firstParagraph[numCharsToKeep + 1] !== ' ' &&
      numCharsToKeep >= minCharsToKeep
    ) {
      numCharsToKeep -= 1;
    }

    firstParagraph = firstParagraph.substring(0, numCharsToKeep + 1).trim();
    return `<p>${firstParagraph}&hellip; <button class="btn-link ${this.moreButtonClass}">more</button></p>`;
  }

  private handleClickDescription(e: MouseEvent) {
    // NOTE: we have to handle the button this way because it gets recreated when switching
    // between full and medium-grid
    const target = e.target ? (e.target as HTMLButtonElement) : undefined;

    if (target && target.classList.contains(this.moreButtonClass)) {
      e.stopPropagation();
      e.preventDefault();
      this.destroyDescription();
      this.expanded = true;
    }
  }

  private get description(): HTMLDivElement | undefined {
    return this.$refs.description as HTMLDivElement;
  }

  private initDescription() {
    if (this.description) {
      this.description.addEventListener('click', this.handleClickDescription);
    }
  }

  private destroyDescription() {
    if (this.description) {
      this.description.removeEventListener('click', this.handleClickDescription);
    }
  }

  private async sendNotifyRequest() {
    this.isSendingNotifyRequest = true;
    await this.$store.dispatch('learningGroups/notifyComingSoon', this.course);
    this.isSendingNotifyRequest = false;
  }

  private mounted() {
    this.initDescription();
  }

  private destroyed() {
    this.destroyDescription();
  }
}
